import type { StatsigBootstrapGlobal } from '@confluence/statsig-client/entry-points/StatsigBootstrapGlobal';
import { CookieLevel, Cookies } from '@confluence/cookies';
import { hashData } from '@confluence/hash';

export const STATSIG_BOOTSTRAP_COOKIE_NAME = 'cc-statsig-caching';

export const getStatsigBootstrap = async (): Promise<StatsigBootstrapGlobal | undefined> => {
	// __STATSIG_BOOTSTRAP__ is from cc-frontend-ssr or bifrost template
	const statsigBootstrap = window.__STATSIG_BOOTSTRAP__;

	if (window.__SSR_ADD_STATSIG_CACHE_HIT_METRIC__ && statsigBootstrap) {
		await setCookie(statsigBootstrap);
	}

	return statsigBootstrap;
};

const setCookie = async (statsigBootstrap: StatsigBootstrapGlobal) => {
	const statsigHash = hashData(
		JSON.stringify({
			...statsigBootstrap,
			experimentValues: { ...statsigBootstrap.experimentValues, time: undefined },
		}),
	);

	if (statsigHash === Cookies.get(STATSIG_BOOTSTRAP_COOKIE_NAME)) {
		return;
	}

	// Cookies.set only works for necessary cookies at this point since Cookies.initialize has not yet been called
	// Cookies.initialize relies on StatsigBootstrap so this can't be moved around
	await Cookies.set(STATSIG_BOOTSTRAP_COOKIE_NAME, statsigHash, undefined, CookieLevel.NECESSARY);
};
